module.exports = __webpack_public_path__ + "img/cloud.8fbd4f90.svg";